import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Prevents browser/proxy caching of API GETs via Cache-Control headers only.
 *
 * Do NOT append a `_t` query param — Nest ValidationPipe with
 * `forbidNonWhitelisted: true` rejects unknown query keys (400 Bad Request).
 */
export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  const url = req.url.toLowerCase();
  const isStaticAsset = /\.(js|mjs|css|woff2?|ttf|eot|otf|svg|png|jpg|jpeg|gif|webp|ico)(\?|$)/i.test(url);
  const isAssetFolder = url.includes('/assets/') || url.includes('/public/') || url.includes('/i18n/');
  const isCrossOrigin = /^https?:\/\//i.test(req.url) && !req.url.startsWith(window.location.origin);

  if (isStaticAsset || isAssetFolder || isCrossOrigin) {
    return next(req);
  }

  const cacheHeaders = {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  };

  const cloned = req.clone({
    setHeaders: cacheHeaders,
  });

  return next(cloned);
};
